import { createReducer } from '@reduxjs/toolkit';

import getAcceptanceToDay from '../../../thunks/coilovers/acceptance/getAcceptanceToDay';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAcceptanceToDayReducer = createReducer(initialState, {
  [getAcceptanceToDay.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getAcceptanceToDay.fulfilled]: (state, {
    payload: {
      data, current_page: currentPage, last_page: lastPage, total
    }
  }) => ({
    ...state,
    loading: false,
    data,
    currentPage,
    lastPage,
    total
  }),
  [getAcceptanceToDay.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getAcceptanceToDayReducer;
